import _ from 'lodash'
import TableInnerActionsBuilder from './TableInnerActionsBuilder'
export default class SearchTablePageTableInnerExtraActionsBuilder extends TableInnerActionsBuilder {
  getDefaultAction (): any {
    return {
      $type: 'a-button'
    }
  }
}
